import { React, useEffect, useState } from "react";
import "../../../styles/desktop/alarmes.css";

const Alarmes = ({ luzesStatus }) => {
    const [alarmeState, setAlarmeStates] = useState({
        alarme1: false,
        alarme2: false,
    });

    useEffect(() => {
        const updateState = () => {
            if (luzesStatus.length > 9) {
                setAlarmeStates({
                    alarme1: luzesStatus[8]?.dados?.[2] === "ON",
                    alarme2: luzesStatus[9]?.dados?.[0] === "ON",
                  });
                  
            }
        };
    
        updateState();
    }, [luzesStatus]);
    

    return (
        <div className="GrupoAlarmes">
            <div className="campoBomba">
                <div className="campoBombaAlarme">
                    <div id="alarme1" className="alarme">
                        <p className="titleAlarme">Bomba d'agua 1</p>
                        <div className={alarmeState.alarme1 ? "alertCircle" : "circleAlarm"} id="circleAlarme1">
                            <p>{alarmeState.alarme1 ? "Defeito" : "Ligada"}</p>
                        </div>
                    </div>
                    <div id="alarme2" className="alarme">    
                        <p className="titleAlarme">Bomba d'agua 2</p>
                        <div className={alarmeState.alarme2 ? "alertCircle" : "circleAlarm"} id="circleAlarme2">
                            <p>{alarmeState.alarme2 ? "Defeito" : "Ligada"}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Alarmes;